import Upload from "./artifacts/contracts/Upload.sol/Upload.json";
import { useState, useEffect } from "react";
import { ethers } from "ethers";
import FileUpload from "./components/FileUpload";
import Display from "./components/Display";
import Modal from "./components/Modal";
import "./App.css";

function App() {
  const [account, setAccount] = useState("");
  const [contract, setContract] = useState(null);
  const [provider, setProvider] = useState(null);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    if (!window.ethereum) {
      alert("MetaMask is not detected. Please install it to use this application.");
      console.error("Ethereum provider not found");
      return;
    }

    const web3Provider = new ethers.providers.Web3Provider(window.ethereum);

    const loadProvider = async () => {
      try {
        window.ethereum.on("chainChanged", () => {
          window.location.reload();
        });

        window.ethereum.on("accountsChanged", () => {
          window.location.reload();
        });

        await web3Provider.send("eth_requestAccounts", []);
        const signer = web3Provider.getSigner();
        const address = await signer.getAddress();
        setAccount(address);

        const contractAddress = "0x20f34861f6f3263c3e6c84472cb8103356c62967";
        const contractInstance = new ethers.Contract(
          contractAddress,
          Upload.abi,
          signer
        );

        setContract(contractInstance);
        setProvider(web3Provider);
      } catch (error) {
        console.error("Error loading provider or contract:", error);
      }
    };

    loadProvider();
  }, []);

  return (
    <>
      {!modalOpen && (
        <button className="share" onClick={() => setModalOpen(true)}>
          Share
        </button>
      )}
      {modalOpen && (
        <Modal setModalOpen={setModalOpen} contract={contract}></Modal>
      )}

      <div className="App">
        <h1 style={{ color: "white" }}>SecureFileNet</h1>
        <div className="bg"></div>
        <div className="bg bg2"></div>
        <div className="bg bg3"></div>

        <p style={{ color: "white" }}>
          Account : {account ? account : "Not connected"}
        </p>
        {contract && provider ? (
          <>
            <FileUpload
              account={account}
              provider={provider}
              contract={contract}
            ></FileUpload>
            <Display contract={contract} account={account}></Display>
          </>
        ) : (
          <p style={{ color: "red" }}>Loading contract or provider...</p>
        )}
      </div>
    </>
  );
}

export default App;
